module.exports = __webpack_public_path__ + "img/ball2_dn.cbc9486d.png";